module.exports = __webpack_public_path__ + "img/we_3.0d3742ff.svg";